<template>
  <v-app class="app-background" v-loading.fullscreen.lock="auth.isLoading">
    <div class="welcome-page">
      <el-card shadow="always" class="welcome-container pa-3">
        <img src="../../assets/logoFix.png" alt srcset class="welcome-image mb-4" />
        <el-form :inline="true" :model="user" class="demo-form-inline w-100">
          <el-input
            v-model="user.nik"
            placeholder="NIK"
            prefix-icon="el-icon-message"
            class="mb-4"
            type="number"
            @keyup.enter.native="loginUser"
          ></el-input>
          <el-input
            v-model="user.password"
            placeholder="Kata Sandi"
            show-password
            prefix-icon="el-icon-lock"
            class="mb-4"
            @keyup.enter.native="loginUser"
          ></el-input>

          <el-form-item class="mt-4 mr-0 w-100">
            <el-button type="primary" @click="loginUser" class="w-100">Masuk</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <div class="bg-ellips"></div>
    </div>
  </v-app>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      showPassword: false,
      remember: false,
      loading: false,
      alert: {},
      user: {
        nik: "",
        password: ""
      }
    };
  },
  methods: {
    ...mapActions({
      login: "auth/login"
    }),
    async loginUser() {
      this.login(this.user);
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth
    })
  }
};
</script>

<style>
.app-background {
  /* background: url("../../assets/backgroundLogin.jpeg") !important; */
}
.title-login {
  color: #1b2733;
  margin: 25px 0 25px 0;
}
.custom-text-field .v-input__control .v-input__slot {
  border-radius: 20px !important;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.05) !important;
  border: solid 1px #dfe2e6 !important;
  background-color: #ffffff;
}
.forgot-password {
  text-decoration: none;
}
.welcome-page {
  text-align: center;
  height: 100%;
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-align: center;
  box-pack: center;
  background: linear-gradient(
    198.13deg,
    #1f36be 0.4%,
    #2883d7 50.55%,
    #2fc5ed 93.01%
  );
  overflow: hidden;
  position: relative;
}
.welcome-page .bg-ellips {
  position: absolute;
  width: 2101px;
  height: 1204px;
  top: 50%;
  z-index: 0;
  border-radius: 50%;
  opacity: 0.3;
  background: linear-gradient(
    190.42deg,
    #1f36be 0.4%,
    #2883d7 50.55%,
    #2fc5ed 93.01%
  );
}
.welcome-container {
  width: 30rem;
  z-index: 9;
}
.welcome-image {
  cursor: pointer;
  width: 16rem;
  height: 6rem;
  object-fit: cover;
}
.w-100 {
  width: 100% !important;
}
.el-form-item__content {
  width: 100% !important;
}
</style>
